var map = {
	"./Group71.png": 7801,
	"./box-search.png": 2607,
	"./carusele1.jpg": 3822,
	"./carusele2.jpg": 5461,
	"./carusele3.jpg": 9041,
	"./carusele4.jpg": 635,
	"./chart-square.png": 4815,
	"./code-1.png": 5273,
	"./empty-wallet.png": 6342,
	"./facebook.png": 8900,
	"./image8.png": 2089,
	"./linkedin.png": 1654,
	"./logo.png": 6949,
	"./logotypes/AmazonLogo.png": 3404,
	"./logotypes/GoogleLogo.png": 5764,
	"./logotypes/UberEatsLogo.png": 5292,
	"./logotypes/Vector.png": 6558,
	"./twitter.png": 3220,
	"./unsplash_bzqU01v-G54.png": 5716
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;